var z = {}, Y = {}, J = {}, w = {}, R = {}, q = { exports: {} }, K, ie;
function Be() {
  if (ie) return K;
  ie = 1;
  var e = 1e3, h = e * 60, u = h * 60, a = u * 24, d = a * 7, m = a * 365.25;
  K = function(n, i) {
    i = i || {};
    var o = typeof n;
    if (o === "string" && n.length > 0)
      return f(n);
    if (o === "number" && isFinite(n))
      return i.long ? t(n) : s(n);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(n)
    );
  };
  function f(n) {
    if (n = String(n), !(n.length > 100)) {
      var i = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
        n
      );
      if (i) {
        var o = parseFloat(i[1]), c = (i[2] || "ms").toLowerCase();
        switch (c) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return o * m;
          case "weeks":
          case "week":
          case "w":
            return o * d;
          case "days":
          case "day":
          case "d":
            return o * a;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return o * u;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return o * h;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return o * e;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return o;
          default:
            return;
        }
      }
    }
  }
  function s(n) {
    var i = Math.abs(n);
    return i >= a ? Math.round(n / a) + "d" : i >= u ? Math.round(n / u) + "h" : i >= h ? Math.round(n / h) + "m" : i >= e ? Math.round(n / e) + "s" : n + "ms";
  }
  function t(n) {
    var i = Math.abs(n);
    return i >= a ? r(n, i, a, "day") : i >= u ? r(n, i, u, "hour") : i >= h ? r(n, i, h, "minute") : i >= e ? r(n, i, e, "second") : n + " ms";
  }
  function r(n, i, o, c) {
    var l = i >= o * 1.5;
    return Math.round(n / o) + " " + c + (l ? "s" : "");
  }
  return K;
}
var W, ae;
function He() {
  if (ae) return W;
  ae = 1;
  function e(h) {
    a.debug = a, a.default = a, a.coerce = r, a.disable = s, a.enable = m, a.enabled = t, a.humanize = Be(), a.destroy = n, Object.keys(h).forEach((i) => {
      a[i] = h[i];
    }), a.names = [], a.skips = [], a.formatters = {};
    function u(i) {
      let o = 0;
      for (let c = 0; c < i.length; c++)
        o = (o << 5) - o + i.charCodeAt(c), o |= 0;
      return a.colors[Math.abs(o) % a.colors.length];
    }
    a.selectColor = u;
    function a(i) {
      let o, c = null, l, g;
      function v(...y) {
        if (!v.enabled)
          return;
        const E = v, _ = Number(/* @__PURE__ */ new Date()), b = _ - (o || _);
        E.diff = b, E.prev = o, E.curr = _, o = _, y[0] = a.coerce(y[0]), typeof y[0] != "string" && y.unshift("%O");
        let C = 0;
        y[0] = y[0].replace(/%([a-zA-Z%])/g, (P, L) => {
          if (P === "%%")
            return "%";
          C++;
          const O = a.formatters[L];
          if (typeof O == "function") {
            const Qe = y[C];
            P = O.call(E, Qe), y.splice(C, 1), C--;
          }
          return P;
        }), a.formatArgs.call(E, y), (E.log || a.log).apply(E, y);
      }
      return v.namespace = i, v.useColors = a.useColors(), v.color = a.selectColor(i), v.extend = d, v.destroy = a.destroy, Object.defineProperty(v, "enabled", {
        enumerable: !0,
        configurable: !1,
        get: () => c !== null ? c : (l !== a.namespaces && (l = a.namespaces, g = a.enabled(i)), g),
        set: (y) => {
          c = y;
        }
      }), typeof a.init == "function" && a.init(v), v;
    }
    function d(i, o) {
      const c = a(this.namespace + (typeof o > "u" ? ":" : o) + i);
      return c.log = this.log, c;
    }
    function m(i) {
      a.save(i), a.namespaces = i, a.names = [], a.skips = [];
      const o = (typeof i == "string" ? i : "").trim().replace(/\s+/g, ",").split(",").filter(Boolean);
      for (const c of o)
        c[0] === "-" ? a.skips.push(c.slice(1)) : a.names.push(c);
    }
    function f(i, o) {
      let c = 0, l = 0, g = -1, v = 0;
      for (; c < i.length; )
        if (l < o.length && (o[l] === i[c] || o[l] === "*"))
          o[l] === "*" ? (g = l, v = c, l++) : (c++, l++);
        else if (g !== -1)
          l = g + 1, v++, c = v;
        else
          return !1;
      for (; l < o.length && o[l] === "*"; )
        l++;
      return l === o.length;
    }
    function s() {
      const i = [
        ...a.names,
        ...a.skips.map((o) => "-" + o)
      ].join(",");
      return a.enable(""), i;
    }
    function t(i) {
      for (const o of a.skips)
        if (f(i, o))
          return !1;
      for (const o of a.names)
        if (f(i, o))
          return !0;
      return !1;
    }
    function r(i) {
      return i instanceof Error ? i.stack || i.message : i;
    }
    function n() {
      console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    return a.enable(a.load()), a;
  }
  return W = e, W;
}
var oe;
function ze() {
  return oe || (oe = 1, function(e, h) {
    h.formatArgs = a, h.save = d, h.load = m, h.useColors = u, h.storage = f(), h.destroy = /* @__PURE__ */ (() => {
      let t = !1;
      return () => {
        t || (t = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
      };
    })(), h.colors = [
      "#0000CC",
      "#0000FF",
      "#0033CC",
      "#0033FF",
      "#0066CC",
      "#0066FF",
      "#0099CC",
      "#0099FF",
      "#00CC00",
      "#00CC33",
      "#00CC66",
      "#00CC99",
      "#00CCCC",
      "#00CCFF",
      "#3300CC",
      "#3300FF",
      "#3333CC",
      "#3333FF",
      "#3366CC",
      "#3366FF",
      "#3399CC",
      "#3399FF",
      "#33CC00",
      "#33CC33",
      "#33CC66",
      "#33CC99",
      "#33CCCC",
      "#33CCFF",
      "#6600CC",
      "#6600FF",
      "#6633CC",
      "#6633FF",
      "#66CC00",
      "#66CC33",
      "#9900CC",
      "#9900FF",
      "#9933CC",
      "#9933FF",
      "#99CC00",
      "#99CC33",
      "#CC0000",
      "#CC0033",
      "#CC0066",
      "#CC0099",
      "#CC00CC",
      "#CC00FF",
      "#CC3300",
      "#CC3333",
      "#CC3366",
      "#CC3399",
      "#CC33CC",
      "#CC33FF",
      "#CC6600",
      "#CC6633",
      "#CC9900",
      "#CC9933",
      "#CCCC00",
      "#CCCC33",
      "#FF0000",
      "#FF0033",
      "#FF0066",
      "#FF0099",
      "#FF00CC",
      "#FF00FF",
      "#FF3300",
      "#FF3333",
      "#FF3366",
      "#FF3399",
      "#FF33CC",
      "#FF33FF",
      "#FF6600",
      "#FF6633",
      "#FF9900",
      "#FF9933",
      "#FFCC00",
      "#FFCC33"
    ];
    function u() {
      if (typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs))
        return !0;
      if (typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/))
        return !1;
      let t;
      return typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
      typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator < "u" && navigator.userAgent && (t = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(t[1], 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
      typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    function a(t) {
      if (t[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + t[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff), !this.useColors)
        return;
      const r = "color: " + this.color;
      t.splice(1, 0, r, "color: inherit");
      let n = 0, i = 0;
      t[0].replace(/%[a-zA-Z%]/g, (o) => {
        o !== "%%" && (n++, o === "%c" && (i = n));
      }), t.splice(i, 0, r);
    }
    h.log = console.debug || console.log || (() => {
    });
    function d(t) {
      try {
        t ? h.storage.setItem("debug", t) : h.storage.removeItem("debug");
      } catch {
      }
    }
    function m() {
      let t;
      try {
        t = h.storage.getItem("debug") || h.storage.getItem("DEBUG");
      } catch {
      }
      return !t && typeof process < "u" && "env" in process && (t = process.env.DEBUG), t;
    }
    function f() {
      try {
        return localStorage;
      } catch {
      }
    }
    e.exports = He()(h);
    const { formatters: s } = e.exports;
    s.j = function(t) {
      try {
        return JSON.stringify(t);
      } catch (r) {
        return "[UnexpectedJSONParseError]: " + r.message;
      }
    };
  }(q, q.exports)), q.exports;
}
var k = {}, se;
function B() {
  if (se) return k;
  se = 1, Object.defineProperty(k, "__esModule", { value: !0 });
  function e() {
    return !(typeof window < "u" && window.document);
  }
  return k.default = e, k;
}
var ue;
function H() {
  if (ue) return R;
  ue = 1;
  var e = R && R.__importDefault || function(f) {
    return f && f.__esModule ? f : { default: f };
  }, h;
  Object.defineProperty(R, "__esModule", { value: !0 }), R.enableDebug = void 0;
  const u = e(ze()), a = e(/* @__PURE__ */ B()), d = "sitecore-jss";
  (0, a.default)() && ((h = process == null ? void 0 : process.env) === null || h === void 0 ? void 0 : h.DEBUG_MULTILINE) === "true" && u.default.formatters.o && u.default.formatters.O && (u.default.formatters.o = u.default.formatters.O);
  const m = (f) => u.default.enable(f);
  return R.enableDebug = m, R.default = {
    common: (0, u.default)(`${d}:common`),
    http: (0, u.default)(`${d}:http`),
    layout: (0, u.default)(`${d}:layout`),
    dictionary: (0, u.default)(`${d}:dictionary`),
    editing: (0, u.default)(`${d}:editing`),
    sitemap: (0, u.default)(`${d}:sitemap`),
    multisite: (0, u.default)(`${d}:multisite`),
    robots: (0, u.default)(`${d}:robots`),
    redirects: (0, u.default)(`${d}:redirects`),
    personalize: (0, u.default)(`${d}:personalize`),
    errorpages: (0, u.default)(`${d}:errorpages`),
    proxy: (0, u.default)(`${d}:proxy`)
  }, R;
}
var Z = {}, I = {}, ce;
function Ye() {
  if (ce) return I;
  ce = 1, Object.defineProperty(I, "__esModule", { value: !0 }), I.EditMode = I.LayoutServicePageState = void 0;
  var e;
  (function(u) {
    u.Preview = "preview", u.Edit = "edit", u.Normal = "normal";
  })(e || (I.LayoutServicePageState = e = {}));
  var h;
  return function(u) {
    u.Chromes = "chromes", u.Metadata = "metadata";
  }(h || (I.EditMode = h = {})), I;
}
var V = {}, le;
function Je() {
  return le || (le = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.EMPTY_DATE_FIELD_VALUE = e.isDynamicPlaceholder = e.getDynamicPlaceholderPattern = void 0, e.getFieldValue = h, e.getChildPlaceholder = u, e.isFieldValueEmpty = m;
    function h(f, s, t) {
      if (!f || !s)
        return t;
      const n = f[s];
      if (n && typeof n.value < "u")
        return n.value;
      const i = f;
      return !i.fields || !i.fields[s] || typeof i.fields[s].value > "u" ? t : i.fields[s].value;
    }
    function u(f, s) {
      return !f || !s || !f.placeholders || !f.placeholders[s] ? [] : f.placeholders[s];
    }
    const a = (f) => new RegExp(`^${f.replace(/\{\*\}+/i, "\\d+")}$`);
    e.getDynamicPlaceholderPattern = a;
    const d = (f) => f.indexOf("{*}") !== -1;
    e.isDynamicPlaceholder = d, e.EMPTY_DATE_FIELD_VALUE = "0001-01-01T00:00:00Z";
    function m(f) {
      const s = (c) => !c.src, t = (c) => !c.src, r = (c) => !c.href, n = (c) => typeof c == "string" ? c === e.EMPTY_DATE_FIELD_VALUE : !(typeof (c == null ? void 0 : c.getMonth) == "function" && !isNaN(c == null ? void 0 : c.getMonth())), i = (c) => c == null ? !0 : typeof c == "object" ? s(c) && t(c) && r(c) && n(c) : typeof c == "number" || typeof c == "boolean" ? !1 : !c || n(c);
      if (!f)
        return !0;
      const o = f;
      return o.value !== void 0 ? i(o.value) : i(f);
    }
  }(V)), V;
}
var X = {}, S = {}, de;
function Te() {
  if (de) return S;
  de = 1, Object.defineProperty(S, "__esModule", { value: !0 }), S.HIDDEN_RENDERING_NAME = S.SITECORE_EDGE_URL_DEFAULT = S.siteNameError = S.JSS_MODE = S.FETCH_WITH = S.SitecoreTemplateId = void 0;
  var e;
  return function(h) {
    h.JssApp = "061cba1554744b918a0617903b102b82", h.DictionaryEntry = "6d1cd89719364a3aa511289a94c2a7b1";
  }(e || (S.SitecoreTemplateId = e = {})), S.FETCH_WITH = {
    GRAPHQL: "GraphQL",
    REST: "REST"
  }, S.JSS_MODE = {
    CONNECTED: "connected",
    DISCONNECTED: "disconnected"
  }, S.siteNameError = "The siteName cannot be empty", S.SITECORE_EDGE_URL_DEFAULT = "https://edge-platform.sitecorecloud.io", S.HIDDEN_RENDERING_NAME = "Hidden Rendering", S;
}
var fe;
function Ke() {
  return fe || (fe = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.traverseComponent = e.traverseField = e.traversePlaceholder = e.getContentStylesheetUrl = e.getContentStylesheetLink = void 0;
    const h = /* @__PURE__ */ Te(), u = /class=".*(\bck-content\b).*"/g, a = (t, r, n = h.SITECORE_EDGE_URL_DEFAULT) => {
      if (!t.sitecore.route)
        return null;
      const i = { loadStyles: !1 };
      return (0, e.traverseComponent)(t.sitecore.route, i), i.loadStyles ? {
        href: (0, e.getContentStylesheetUrl)(r, n),
        rel: "stylesheet"
      } : null;
    };
    e.getContentStylesheetLink = a;
    const d = (t, r = h.SITECORE_EDGE_URL_DEFAULT) => `${r}/v1/files/pages/styles/content-styles.css?sitecoreContextId=${t}`;
    e.getContentStylesheetUrl = d;
    const m = (t, r) => {
      r.loadStyles || t.forEach((n) => {
        (0, e.traverseComponent)(n, r);
      });
    };
    e.traversePlaceholder = m;
    const f = (t, r) => {
      !t || typeof t != "object" || r.loadStyles || ("editable" in t && t.editable ? r.loadStyles = u.test(t.editable) : "value" in t && typeof t.value == "string" ? r.loadStyles = u.test(t.value) : "fields" in t ? Object.values(t.fields).forEach((n) => {
        (0, e.traverseField)(n, r);
      }) : Array.isArray(t) && t.forEach((n) => {
        (0, e.traverseField)(n, r);
      }));
    };
    e.traverseField = f;
    const s = (t, r) => {
      if (r.loadStyles)
        return;
      "fields" in t && t.fields && Object.values(t.fields).forEach((i) => {
        (0, e.traverseField)(i, r);
      });
      const n = t.placeholders || {};
      Object.keys(n).forEach((i) => {
        (0, e.traversePlaceholder)(n[i], r);
      });
    };
    e.traverseComponent = s;
  }(X)), X;
}
var D = {}, U = {}, he;
function Ue() {
  if (he) return U;
  he = 1, Object.defineProperty(U, "__esModule", { value: !0 }), U.LayoutServiceBase = void 0;
  class e {
  }
  return U.LayoutServiceBase = e, U;
}
var F = {}, Q = {}, ve;
function We() {
  if (ve) return Q;
  ve = 1, Object.defineProperty(Q, "__esModule", { value: !0 });
  class e {
    constructor(u) {
      this.timeout = u, this.timeoutId = void 0;
    }
    /**
     * Creates a timeout promise
     */
    get start() {
      return new Promise((u, a) => {
        this.timeoutId = setTimeout(() => {
          const d = new Error(`Request timed out, timeout of ${this.timeout}ms is exceeded`);
          d.name = "AbortError", a(d);
        }, this.timeout);
      });
    }
    /**
     * Clears the timeout from timeout promise
     */
    clear() {
      this.timeoutId && clearTimeout(this.timeoutId);
    }
  }
  return Q.default = e, Q;
}
var ge;
function Ze() {
  if (ge) return F;
  ge = 1;
  var e = F && F.__awaiter || function(f, s, t, r) {
    function n(i) {
      return i instanceof t ? i : new t(function(o) {
        o(i);
      });
    }
    return new (t || (t = Promise))(function(i, o) {
      function c(v) {
        try {
          g(r.next(v));
        } catch (y) {
          o(y);
        }
      }
      function l(v) {
        try {
          g(r.throw(v));
        } catch (y) {
          o(y);
        }
      }
      function g(v) {
        v.done ? i(v.value) : n(v.value).then(c, l);
      }
      g((r = r.apply(f, s || [])).next());
    });
  }, h = F && F.__rest || function(f, s) {
    var t = {};
    for (var r in f) Object.prototype.hasOwnProperty.call(f, r) && s.indexOf(r) < 0 && (t[r] = f[r]);
    if (f != null && typeof Object.getOwnPropertySymbols == "function")
      for (var n = 0, r = Object.getOwnPropertySymbols(f); n < r.length; n++)
        s.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(f, r[n]) && (t[r[n]] = f[r[n]]);
    return t;
  }, u = F && F.__importDefault || function(f) {
    return f && f.__esModule ? f : { default: f };
  };
  Object.defineProperty(F, "__esModule", { value: !0 }), F.NativeDataFetcher = void 0;
  const a = u(/* @__PURE__ */ H()), d = u(/* @__PURE__ */ We());
  class m {
    constructor(s = {}) {
      this.config = s;
    }
    /**
     * Implements a data fetcher.
     * @param {string} url The URL to request (may include query string)
     * @param {RequestInit} [options] Optional fetch options
     * @returns {Promise<NativeDataFetcherResponse<T>>} response
     */
    fetch(s) {
      return e(this, arguments, void 0, function* (t, r = {}) {
        var n;
        const i = this.config, { debugger: o, fetch: c } = i, l = h(i, ["debugger", "fetch"]), g = Date.now(), v = c || fetch, y = o || a.default.http, E = this.getRequestInit(Object.assign(Object.assign({}, l), r)), _ = [v(t, E)];
        l.timeout && (this.abortTimeout = new d.default(l.timeout), _.push(this.abortTimeout.start)), y("Request initiated: %o", Object.assign({ url: t, headers: this.extractDebugHeaders(E.headers) }, E));
        try {
          const b = yield Promise.race(_).then((p) => {
            var P;
            return (P = this.abortTimeout) === null || P === void 0 || P.clear(), p;
          }), C = yield this.parseResponse(b, y);
          if (!b.ok) {
            const p = this.createError(b, C);
            throw y("Response error: %o", p.response), p;
          }
          return y("Response in %dms: %o", Date.now() - g, {
            status: b.status,
            statusText: b.statusText,
            headers: this.extractDebugHeaders(b.headers),
            url: b.url,
            data: C
          }), Object.assign(Object.assign({}, b), { data: C });
        } catch (b) {
          throw (n = this.abortTimeout) === null || n === void 0 || n.clear(), y("Request failed: %o", b), b;
        }
      });
    }
    /**
     * Perform a GET request
     * @param {string} url The URL to request (may include query string)
     * @param {RequestInit} [options] Fetch options
     * @returns {Promise<NativeDataFetcherResponse<T>>} response
     */
    get(s) {
      return e(this, arguments, void 0, function* (t, r = {}) {
        return this.fetch(t, Object.assign({ method: "GET" }, r));
      });
    }
    /**
     * Perform a POST request
     * @param {string} url The URL to request (may include query string)
     * @param {unknown} body The data to send with the request
     * @param {RequestInit} [options] Fetch options
     * @returns {Promise<NativeDataFetcherResponse<T>>} response
     */
    post(s, t) {
      return e(this, arguments, void 0, function* (r, n, i = {}) {
        return this.fetch(r, Object.assign({ method: "POST", body: JSON.stringify(n) }, i));
      });
    }
    /**
     * Perform a DELETE request
     * @param {string} url The URL to request (may include query string)
     * @param {RequestInit} [options] Fetch options
     * @returns {Promise<NativeDataFetcherResponse<T>>} response
     */
    delete(s) {
      return e(this, arguments, void 0, function* (t, r = {}) {
        return this.fetch(t, Object.assign({ method: "DELETE" }, r));
      });
    }
    /**
     * Perform a PUT request
     * @param {string} url The URL to request (may include query string)
     * @param {unknown} body The data to send with the request
     * @param {RequestInit} [options] Fetch options
     * @returns {Promise<NativeDataFetcherResponse<T>>} response
     */
    put(s, t) {
      return e(this, arguments, void 0, function* (r, n, i = {}) {
        return this.fetch(r, Object.assign({ method: "PUT", body: JSON.stringify(n) }, i));
      });
    }
    /**
     * Perform a HEAD request
     * @param {string} url The URL to request (may include query string)
     * @param {RequestInit} [options] Fetch options
     * @returns {Promise<NativeDataFetcherResponse<T>>} response
     */
    head(s, t = {}) {
      return this.fetch(s, Object.assign({ method: "HEAD" }, t));
    }
    /**
     * Determines settings for the request
     * @param {RequestInit} init Custom settings for request
     * @returns {RequestInit} The final request settings
     */
    getRequestInit(s = {}) {
      const t = new Headers(s.headers);
      return s.method || (s.method = s.body ? "POST" : "GET"), s.headers = t, s;
    }
    /**
     * Safely extract all headers for debug logging
     * @param {HeadersInit} incomingHeaders Incoming headers
     * @returns Object with headers as key/value pairs
     */
    extractDebugHeaders(s = {}) {
      const t = {};
      return typeof (s == null ? void 0 : s.forEach) != "string" && s.forEach && (s == null || s.forEach((r, n) => {
        t[n] = r;
      })), t;
    }
    /**
     * Parses the response data.
     * @param {Response} response - The fetch response object.
     * @param {Function} debug - The debug logger function.
     * @returns {Promise<unknown>} - The parsed response data.
     */
    parseResponse(s, t) {
      return e(this, void 0, void 0, function* () {
        const r = s.headers.get("Content-Type") || "";
        try {
          return r.includes("application/json") ? yield s.json() : yield s.text();
        } catch (n) {
          t("Response parsing error: %o", n);
          return;
        }
      });
    }
    /**
     * Creates a custom error for fetch failures.
     * @param {Response} response - The fetch response object.
     * @param {unknown} data - The parsed response data.
     * @returns {NativeDataFetcherError} - The constructed error object.
     */
    createError(s, t) {
      return Object.assign(Object.assign({}, new Error(`HTTP ${s.status} ${s.statusText}`)), { response: {
        status: s.status,
        statusText: s.statusText,
        headers: this.extractDebugHeaders(s.headers),
        data: t
      } });
    }
  }
  return F.NativeDataFetcher = m, F;
}
var A = {}, M = {}, ye;
function Me() {
  return ye || (ye = 1, function(e) {
    var h = M && M.__importDefault || function(l) {
      return l && l.__esModule ? l : { default: l };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.mergeURLSearchParams = e.escapeNonSpecialQuestionMarks = e.areURLSearchParamsEqual = e.isRegexOrUrl = e.enforceCors = e.getAllowedOriginsFromEnv = e.isTimeoutError = e.isAbsoluteUrl = void 0, e.resolveUrl = d;
    const u = h(/* @__PURE__ */ B());
    function a(l) {
      return Object.keys(l).map((g) => `${encodeURIComponent(g)}=${encodeURIComponent(String(l[g]))}`).join("&");
    }
    function d(l, g = {}) {
      if (!l)
        throw new RangeError("url must be a non-empty string");
      if ((0, u.default)()) {
        const E = new URL(l);
        for (const b in g)
          ({}).hasOwnProperty.call(g, b) && E.searchParams.append(b, String(g[b]));
        return E.toString();
      }
      const v = a(g);
      return l.indexOf("?") !== -1 ? `${l}&${v}` : `${l}?${v}`;
    }
    const m = (l) => {
      if (!l)
        return !1;
      if (typeof l != "string")
        throw new TypeError("Expected a string");
      return /^[a-z][a-z0-9+.-]*:/.test(l);
    };
    e.isAbsoluteUrl = m;
    const f = (l) => {
      var g;
      return ((g = l.response) === null || g === void 0 ? void 0 : g.status) === 408 || l.name === "AbortError";
    };
    e.isTimeoutError = f;
    const s = (l) => "^" + l.replace(/\//g, "\\/").replace(/\./g, "\\.").replace(/\*/g, ".*") + "$", t = () => process.env.JSS_ALLOWED_ORIGINS ? process.env.JSS_ALLOWED_ORIGINS.replace(" ", "").split(",") : [];
    e.getAllowedOriginsFromEnv = t;
    const r = (l, g, v) => {
      if (!l.headers.origin)
        return !0;
      v = (0, e.getAllowedOriginsFromEnv)().concat(v || []);
      const E = g.getHeader("Access-Control-Allow-Origin");
      E && v.push(E);
      const _ = l.headers.origin;
      return _ && v.some((b) => _ === b || new RegExp(s(b)).test(_)) ? (g.setHeader("Access-Control-Allow-Origin", _), g.setHeader("Access-Control-Allow-Methods", "GET, POST, OPTIONS, DELETE, PUT, PATCH"), l.method === "OPTIONS" && g.setHeader("Access-Control-Allow-Headers", "Content-Type, Authorization"), !0) : !1;
    };
    e.enforceCors = r;
    const n = (l) => (l = l.slice(0, -1), /^\/[a-zA-Z0-9\-\/]+(\?([a-zA-Z0-9\-_]+=[a-zA-Z0-9\-_]+)(&[a-zA-Z0-9\-_]+=[a-zA-Z0-9\-_]+)*)?$/.test(l) ? "url" : "regex");
    e.isRegexOrUrl = n;
    const i = (l, g) => {
      const v = (y) => [...y.entries()].sort(([E], [_]) => E.localeCompare(_)).map(([E, _]) => `${E}=${_}`).join("&");
      return v(l) === v(g);
    };
    e.areURLSearchParamsEqual = i;
    const o = (l) => {
      const g = /(\\)?\?/g, v = /\(\?!$/, y = /[.*+)\[\]|\(]$/;
      let E = "", _ = 0, b;
      for (; (b = g.exec(l)) !== null; ) {
        const C = b.index, p = l.slice(_, C), P = b[1] !== void 0, L = v.test(p.slice(-3)), O = y.test(p.slice(-1));
        P || L || O ? E += l.slice(_, C + 1) : E += l.slice(_, C) + "\\?", _ = C + 1;
      }
      return E += l.slice(_), E;
    };
    e.escapeNonSpecialQuestionMarks = o;
    const c = (l, g) => {
      const v = new URLSearchParams();
      for (const [y, E] of l.entries())
        v.set(y, E);
      for (const [y, E] of g.entries())
        v.set(y, E);
      return v.toString();
    };
    e.mergeURLSearchParams = c;
  }(M)), M;
}
var me;
function Ve() {
  if (me) return A;
  me = 1;
  var e = A && A.__awaiter || function(d, m, f, s) {
    function t(r) {
      return r instanceof f ? r : new f(function(n) {
        n(r);
      });
    }
    return new (f || (f = Promise))(function(r, n) {
      function i(l) {
        try {
          c(s.next(l));
        } catch (g) {
          n(g);
        }
      }
      function o(l) {
        try {
          c(s.throw(l));
        } catch (g) {
          n(g);
        }
      }
      function c(l) {
        l.done ? r(l.value) : t(l.value).then(i, o);
      }
      c((s = s.apply(d, m || [])).next());
    });
  };
  Object.defineProperty(A, "__esModule", { value: !0 }), A.ResponseError = void 0, A.fetchData = a;
  const h = /* @__PURE__ */ Me();
  class u extends Error {
    constructor(m, f) {
      super(m), Object.setPrototypeOf(this, u.prototype), this.response = f;
    }
  }
  A.ResponseError = u;
  function a(d, m) {
    return e(this, arguments, void 0, function* (f, s, t = {}) {
      return (yield s((0, h.resolveUrl)(f, t))).data;
    });
  }
  return A;
}
var Ee;
function Xe() {
  if (Ee) return D;
  Ee = 1;
  var e = D && D.__awaiter || function(s, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(c) {
        c(o);
      });
    }
    return new (r || (r = Promise))(function(o, c) {
      function l(y) {
        try {
          v(n.next(y));
        } catch (E) {
          c(E);
        }
      }
      function g(y) {
        try {
          v(n.throw(y));
        } catch (E) {
          c(E);
        }
      }
      function v(y) {
        y.done ? o(y.value) : i(y.value).then(l, g);
      }
      v((n = n.apply(s, t || [])).next());
    });
  }, h = D && D.__importDefault || function(s) {
    return s && s.__esModule ? s : { default: s };
  };
  Object.defineProperty(D, "__esModule", { value: !0 }), D.RestLayoutService = void 0;
  const u = /* @__PURE__ */ Ue(), a = /* @__PURE__ */ Ze(), d = /* @__PURE__ */ Ve(), m = h(/* @__PURE__ */ H());
  class f extends u.LayoutServiceBase {
    constructor(t) {
      super(), this.serviceConfig = t, this.getFetchParams = (r) => {
        var n;
        return {
          sc_apikey: this.serviceConfig.apiKey,
          sc_site: this.serviceConfig.siteName,
          sc_lang: r || "",
          tracking: (n = this.serviceConfig.tracking) !== null && n !== void 0 ? n : !0
        };
      }, this.getDefaultFetcher = (r, n) => {
        const i = { debugger: m.default.layout };
        let o;
        r && (o = this.setupReqHeaders(r));
        const c = new a.NativeDataFetcher(i);
        return (l, g) => e(this, void 0, void 0, function* () {
          const v = yield c.fetch(l, Object.assign(Object.assign({}, g), { headers: o }));
          return n && this.setupResHeaders(n, v), v;
        });
      };
    }
    /**
     * Fetch layout data for an item.
     * @param {string} itemPath item path to fetch layout data for.
     * @param {string} [language] the language to fetch layout data for.
     * @param {IncomingMessage} [req] Request instance
     * @param {ServerResponse} [res] Response instance
     * @returns {Promise<LayoutServiceData>} layout service data
     * @throws {Error} the item with the specified path is not found
     */
    fetchLayoutData(t, r, n, i) {
      return e(this, void 0, void 0, function* () {
        var o;
        const c = this.getFetchParams(r);
        m.default.layout("fetching layout data for %s %s %s", t, r, this.serviceConfig.siteName);
        const l = this.serviceConfig.dataFetcherResolver ? this.serviceConfig.dataFetcherResolver(n, i) : this.getDefaultFetcher(n, i), g = this.resolveLayoutServiceUrl("render");
        try {
          return yield (0, d.fetchData)(g, l, Object.assign({ item: t }, c));
        } catch (v) {
          if (((o = v.response) === null || o === void 0 ? void 0 : o.status) === 404)
            return v.response.data;
          throw v;
        }
      });
    }
    /**
     * Fetch layout data for a particular placeholder.
     * Makes a request to Sitecore Layout Service for the specified placeholder in
     * a specific route item. Allows you to retrieve rendered data for individual placeholders instead of entire routes.
     * @param {string} placeholderName the name of the placeholder to fetch layout data for.
     * @param {string} itemPath the path to the item to fetch layout data for.
     * @param {string} [language] the language to fetch data for.
     * @param {IncomingMessage} [req] Request instance
     * @param {ServerResponse} [res] Response instance
     * @returns {Promise<PlaceholderData>} placeholder data
     */
    fetchPlaceholderData(t, r, n, i, o) {
      const c = this.getFetchParams(n);
      m.default.layout("fetching placeholder data for %s %s %s %s", t, r, n, this.serviceConfig.siteName);
      const l = this.serviceConfig.dataFetcherResolver ? this.serviceConfig.dataFetcherResolver(i, o) : this.getDefaultFetcher(i, o), g = this.resolveLayoutServiceUrl("placeholder");
      return (0, d.fetchData)(g, l, Object.assign({ placeholderName: t, item: r }, c));
    }
    /**
     * Resolves layout service url
     * @param {string} apiType which layout service API to call ('render' or 'placeholder')
     * @returns the layout service url
     */
    resolveLayoutServiceUrl(t) {
      const { apiHost: r = "", configurationName: n = "jss" } = this.serviceConfig;
      return `${r}/sitecore/api/layout/${t}/${n}`;
    }
    /**
     * Creates an HTTP `Headers` object populated with headers from the incoming request.
     * @param {IncomingMessage} [req] - The incoming HTTP request, used to extract headers.
     * @returns {Headers} - An instance of the `Headers` object populated with the extracted headers.
     */
    setupReqHeaders(t) {
      const r = new Headers();
      return t != null && t.headers && (Object.entries(t.headers).forEach(([n, i]) => {
        i && r.set(n, Array.isArray(i) ? i.join(", ") : i);
      }), t.headers.cookie && r.set("cookie", t.headers.cookie), t.headers.referer && r.set("referer", t.headers.referer), t.headers["user-agent"] && r.set("user-agent", t.headers["user-agent"]), t.socket.remoteAddress && r.set("X-Forwarded-For", t.socket.remoteAddress)), r;
    }
    /**
     * Setup response headers based on response from layout service
     * @param {ServerResponse} res Response instance
     * @param {NativeDataFetcherResponse<T>} serverRes
     * @returns {NativeDataFetcherResponse} response
     */
    setupResHeaders(t, r) {
      m.default.layout("performing response header passing");
      const n = r.headers;
      if (n instanceof Headers) {
        const i = n.get("set-cookie");
        i && t.setHeader("set-cookie", i);
      }
      return r;
    }
  }
  return D.RestLayoutService = f, D;
}
var j = {}, _e;
function xe() {
  return _e || (_e = 1, function(e) {
    var h = j && j.__awaiter || function(f, s, t, r) {
      function n(i) {
        return i instanceof t ? i : new t(function(o) {
          o(i);
        });
      }
      return new (t || (t = Promise))(function(i, o) {
        function c(v) {
          try {
            g(r.next(v));
          } catch (y) {
            o(y);
          }
        }
        function l(v) {
          try {
            g(r.throw(v));
          } catch (y) {
            o(y);
          }
        }
        function g(v) {
          v.done ? i(v.value) : n(v.value).then(c, l);
        }
        g((r = r.apply(f, s || [])).next());
      });
    }, u = j && j.__importDefault || function(f) {
      return f && f.__esModule ? f : { default: f };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.GraphQLLayoutService = e.GRAPHQL_LAYOUT_QUERY_NAME = void 0;
    const a = /* @__PURE__ */ Ue(), d = u(/* @__PURE__ */ H());
    e.GRAPHQL_LAYOUT_QUERY_NAME = "JssLayoutQuery";
    class m extends a.LayoutServiceBase {
      /**
       * Fetch layout data using the Sitecore GraphQL endpoint.
       * @param {GraphQLLayoutServiceConfig} serviceConfig configuration
       */
      constructor(s) {
        super(), this.serviceConfig = s, this.graphQLClient = this.getGraphQLClient();
      }
      /**
       * Fetch layout data for an item.
       * @param {string} itemPath item path to fetch layout data for.
       * @param {string} [language] the language to fetch layout data for.
       * @returns {Promise<LayoutServiceData>} layout service data
       */
      fetchLayoutData(s, t) {
        return h(this, void 0, void 0, function* () {
          var r, n;
          const i = this.getLayoutQuery(s, t);
          d.default.layout("fetching layout data for %s %s %s", s, t, this.serviceConfig.siteName);
          const o = yield this.graphQLClient.request(i);
          return ((n = (r = o == null ? void 0 : o.layout) === null || r === void 0 ? void 0 : r.item) === null || n === void 0 ? void 0 : n.rendered) || {
            sitecore: { context: { pageEditing: !1, language: t }, route: null }
          };
        });
      }
      /**
       * Gets a GraphQL client that can make requests to the API. Uses graphql-request as the default
       * library for fetching graphql data (@see GraphQLRequestClient). Override this method if you
       * want to use something else.
       * @returns {GraphQLClient} implementation
       */
      getGraphQLClient() {
        if (!this.serviceConfig.clientFactory)
          throw new Error("clientFactory needs to be provided when initializing GraphQL client.");
        return this.serviceConfig.clientFactory({
          debugger: d.default.layout,
          retries: this.serviceConfig.retries,
          retryStrategy: this.serviceConfig.retryStrategy
        });
      }
      /**
       * Returns GraphQL Layout query
       * @param {string} itemPath page route
       * @param {string} [language] language
       * @returns {string} GraphQL query
       */
      getLayoutQuery(s, t) {
        const r = t ? `, language:"${t}"` : "", n = this.serviceConfig.formatLayoutQuery ? this.serviceConfig.formatLayoutQuery(this.serviceConfig.siteName, s, t) : `layout(site:"${this.serviceConfig.siteName}", routePath:"${s}"${r})`;
        return `query ${e.GRAPHQL_LAYOUT_QUERY_NAME} {
      ${n}{
        item {
          rendered
        }
      }
    }`;
      }
    }
    e.GraphQLLayoutService = m;
  }(j)), j;
}
var x = {}, be;
function et() {
  return be || (be = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getStylesheetUrl = void 0, e.getComponentLibraryStylesheetLinks = d;
    const h = /* @__PURE__ */ $e(), u = /* @__PURE__ */ Te(), a = /-library--([^\s]+)/;
    function d(t, r, n = u.SITECORE_EDGE_URL_DEFAULT) {
      const i = /* @__PURE__ */ new Set();
      return t.sitecore.route ? (s(t.sitecore.route, i), [...i].map((o) => ({
        href: (0, e.getStylesheetUrl)(o, r, n),
        rel: "stylesheet"
      }))) : [];
    }
    const m = (t, r, n = u.SITECORE_EDGE_URL_DEFAULT) => `${n}/v1/files/components/styles/${t}.css?sitecoreContextId=${r}`;
    e.getStylesheetUrl = m;
    const f = (t, r) => {
      t.map((n) => s(n, r));
    }, s = (t, r) => {
      var n, i, o, c, l, g, v;
      let y;
      "params" in t && t.params && (y = ((i = (n = t.params.CSSStyles) === null || n === void 0 ? void 0 : n.match(a)) === null || i === void 0 ? void 0 : i[1]) || ((c = (o = t.params.Styles) === null || o === void 0 ? void 0 : o.match(a)) === null || c === void 0 ? void 0 : c[1]) || t.params.LibraryId || void 0), !y && "fields" in t && t.fields && (y = ((l = (0, h.getFieldValue)(t.fields, "CSSStyles", "").match(a)) === null || l === void 0 ? void 0 : l[1]) || ((g = (0, h.getFieldValue)(t.fields, "Styles", "").match(a)) === null || g === void 0 ? void 0 : g[1]) || (0, h.getFieldValue)(t.fields, "LibraryId", "") || void 0), !y && "attributes" in t && typeof t.attributes.class == "string" && (y = (v = t.attributes.class.match(a)) === null || v === void 0 ? void 0 : v[1]), y && r.add(y);
      const E = t.placeholders || {};
      Object.keys(E).forEach((_) => {
        f(E[_], r);
      });
    };
  }(x)), x;
}
var Ce;
function $e() {
  return Ce || (Ce = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getComponentLibraryStylesheetLinks = e.GRAPHQL_LAYOUT_QUERY_NAME = e.GraphQLLayoutService = e.RestLayoutService = e.getContentStylesheetLink = e.EMPTY_DATE_FIELD_VALUE = e.getDynamicPlaceholderPattern = e.isDynamicPlaceholder = e.isFieldValueEmpty = e.getChildPlaceholder = e.getFieldValue = e.EditMode = e.LayoutServicePageState = void 0;
    var h = /* @__PURE__ */ Ye();
    Object.defineProperty(e, "LayoutServicePageState", { enumerable: !0, get: function() {
      return h.LayoutServicePageState;
    } }), Object.defineProperty(e, "EditMode", { enumerable: !0, get: function() {
      return h.EditMode;
    } });
    var u = /* @__PURE__ */ Je();
    Object.defineProperty(e, "getFieldValue", { enumerable: !0, get: function() {
      return u.getFieldValue;
    } }), Object.defineProperty(e, "getChildPlaceholder", { enumerable: !0, get: function() {
      return u.getChildPlaceholder;
    } }), Object.defineProperty(e, "isFieldValueEmpty", { enumerable: !0, get: function() {
      return u.isFieldValueEmpty;
    } }), Object.defineProperty(e, "isDynamicPlaceholder", { enumerable: !0, get: function() {
      return u.isDynamicPlaceholder;
    } }), Object.defineProperty(e, "getDynamicPlaceholderPattern", { enumerable: !0, get: function() {
      return u.getDynamicPlaceholderPattern;
    } }), Object.defineProperty(e, "EMPTY_DATE_FIELD_VALUE", { enumerable: !0, get: function() {
      return u.EMPTY_DATE_FIELD_VALUE;
    } });
    var a = /* @__PURE__ */ Ke();
    Object.defineProperty(e, "getContentStylesheetLink", { enumerable: !0, get: function() {
      return a.getContentStylesheetLink;
    } });
    var d = /* @__PURE__ */ Xe();
    Object.defineProperty(e, "RestLayoutService", { enumerable: !0, get: function() {
      return d.RestLayoutService;
    } });
    var m = /* @__PURE__ */ xe();
    Object.defineProperty(e, "GraphQLLayoutService", { enumerable: !0, get: function() {
      return m.GraphQLLayoutService;
    } }), Object.defineProperty(e, "GRAPHQL_LAYOUT_QUERY_NAME", { enumerable: !0, get: function() {
      return m.GRAPHQL_LAYOUT_QUERY_NAME;
    } });
    var f = /* @__PURE__ */ et();
    Object.defineProperty(e, "getComponentLibraryStylesheetLinks", { enumerable: !0, get: function() {
      return f.getComponentLibraryStylesheetLinks;
    } });
  }(Z)), Z;
}
var T = {}, Se;
function Ne() {
  if (Se) return T;
  Se = 1, Object.defineProperty(T, "__esModule", { value: !0 }), T.MetadataKind = T.LayoutKind = void 0;
  var e;
  (function(u) {
    u.Final = "final", u.Shared = "shared";
  })(e || (T.LayoutKind = e = {}));
  var h;
  return function(u) {
    u.Open = "open", u.Close = "close";
  }(h || (T.MetadataKind = h = {})), T;
}
var pe;
function tt() {
  return pe || (pe = 1, function(e) {
    var h = w && w.__awaiter || function(t, r, n, i) {
      function o(c) {
        return c instanceof n ? c : new n(function(l) {
          l(c);
        });
      }
      return new (n || (n = Promise))(function(c, l) {
        function g(E) {
          try {
            y(i.next(E));
          } catch (_) {
            l(_);
          }
        }
        function v(E) {
          try {
            y(i.throw(E));
          } catch (_) {
            l(_);
          }
        }
        function y(E) {
          E.done ? c(E.value) : o(E.value).then(g, v);
        }
        y((i = i.apply(t, r || [])).next());
      });
    }, u = w && w.__importDefault || function(t) {
      return t && t.__esModule ? t : { default: t };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.GraphQLEditingService = e.dictionaryQuery = e.query = void 0;
    const a = u(/* @__PURE__ */ H()), d = /* @__PURE__ */ $e(), m = /* @__PURE__ */ Ne(), f = 1e3;
    e.query = `
 query EditingQuery(
    $siteName: String!
    $itemId: String!
    $language: String!
    $version: String
    $after: String
    $pageSize: Int = ${f}
) {
    item(path: $itemId, language: $language, version: $version) {
      rendered
    }
    site {
      siteInfo(site: $siteName) {
        dictionary(language: $language, first: $pageSize, after: $after) {
          results {
            key
            value
          }
          pageInfo {
            endCursor
            hasNext
          }
        }
      }
    }
  }
`, e.dictionaryQuery = `
  query EditingDictionaryQuery(
    $siteName: String!
    $language: String!
    $after: String
    $pageSize: Int = ${f}
  ) {
    site {
      siteInfo(site: $siteName) {
        dictionary(language: $language, first: $pageSize, after: $after) {
          results {
            key
            value
          }
          pageInfo {
            endCursor
            hasNext
          }
        }
      }
    }
  }
`;
    class s {
      /**
       * Fetch layout data using the Sitecore GraphQL endpoint.
       * @param {GraphQLLayoutServiceConfig} serviceConfig configuration
       */
      constructor(r) {
        this.serviceConfig = r, this.graphQLClient = this.getGraphQLClient();
      }
      /**
       * Fetches editing data. Provides the layout data and dictionary phrases
       * @param {object} variables - The parameters for fetching editing data.
       * @param {string} variables.siteName - The site name.
       * @param {string} variables.itemId - The item id (path) to fetch layout data for.
       * @param {string} variables.language - The language to fetch layout data for.
       * @param {string} [variables.version] - The version of the item (optional).
       * @param {LayoutKind} [variables.layoutKind] - The final or shared layout variant.
       * @returns {Promise} The layout data and dictionary phrases.
       */
      fetchEditingData(r) {
        return h(this, arguments, void 0, function* ({ siteName: n, itemId: i, language: o, version: c, layoutKind: l = m.LayoutKind.Final }) {
          var g, v, y, E, _;
          if (a.default.editing("fetching editing data for %s %s %s %s", n, i, o, c, l), !n)
            throw new RangeError("The site name must be a non-empty string");
          if (!o)
            throw new RangeError("The language must be a non-empty string");
          const b = {};
          let C = [], p = !0, P = "";
          const L = yield this.graphQLClient.request(e.query, {
            siteName: n,
            itemId: i,
            version: c,
            language: o
          }, {
            headers: {
              sc_layoutKind: l
            }
          });
          for (!((v = (g = L == null ? void 0 : L.site) === null || g === void 0 ? void 0 : g.siteInfo) === null || v === void 0) && v.dictionary ? (C = L.site.siteInfo.dictionary.results, p = L.site.siteInfo.dictionary.pageInfo.hasNext, P = L.site.siteInfo.dictionary.pageInfo.endCursor) : p = !1; p; ) {
            const O = yield this.graphQLClient.request(e.dictionaryQuery, {
              siteName: n,
              language: o,
              after: P
            });
            !((E = (y = O == null ? void 0 : O.site) === null || y === void 0 ? void 0 : y.siteInfo) === null || E === void 0) && E.dictionary ? (C = C.concat(O.site.siteInfo.dictionary.results), p = O.site.siteInfo.dictionary.pageInfo.hasNext, P = O.site.siteInfo.dictionary.pageInfo.endCursor) : p = !1;
          }
          return C.forEach((O) => b[O.key] = O.value), {
            layoutData: ((_ = L == null ? void 0 : L.item) === null || _ === void 0 ? void 0 : _.rendered) || {
              sitecore: {
                context: { pageEditing: !0, language: o, editMode: d.EditMode.Metadata },
                route: null
              }
            },
            dictionary: b
          };
        });
      }
      /**
       * Gets a GraphQL client that can make requests to the API.
       * @returns {GraphQLClient} implementation
       */
      getGraphQLClient() {
        if (!this.serviceConfig.clientFactory)
          throw new Error("clientFactory needs to be provided when initializing GraphQL client.");
        return this.serviceConfig.clientFactory({
          debugger: a.default.editing,
          headers: {
            sc_editMode: "true"
          }
        });
      }
    }
    e.GraphQLEditingService = s;
  }(w)), w;
}
var $ = {}, Oe;
function Ge() {
  return Oe || (Oe = 1, function(e) {
    var h = $ && $.__importDefault || function(r) {
      return r && r.__esModule ? r : { default: r };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getJssPagesClientData = e.handleEditorAnchors = e.resetEditorChromes = e.isEditorActive = e.HorizonEditor = e.ChromeRediscoveryGlobalFunctionName = e.ExperienceEditor = e.EDITING_ALLOWED_ORIGINS = e.PAGES_EDITING_MARKER = e.QUERY_PARAM_EDITING_SECRET = e.DEFAULT_PLACEHOLDER_UID = void 0;
    const u = h(/* @__PURE__ */ B());
    e.DEFAULT_PLACEHOLDER_UID = "00000000-0000-0000-0000-000000000000", e.QUERY_PARAM_EDITING_SECRET = "secret", e.PAGES_EDITING_MARKER = "jss-hrz-editing", e.EDITING_ALLOWED_ORIGINS = ["https://pages.sitecorecloud.io"];
    class a {
      /**
       * Determines whether the current execution context is within a Experience Editor.
       * Experience Editor environment can be identified only in the browser
       * @returns true if executing within a Experience Editor
       */
      static isActive() {
        if ((0, u.default)())
          return !1;
        const n = window.Sitecore;
        return !!(n && n.PageModes && n.PageModes.ChromeManager);
      }
      static resetChromes() {
        (0, u.default)() || window.Sitecore.PageModes.ChromeManager.resetChromes();
      }
    }
    e.ExperienceEditor = a, e.ChromeRediscoveryGlobalFunctionName = {
      name: "Sitecore.Horizon.ResetChromes"
    };
    class d {
      /**
       * Determines whether the current execution context is within a Pages Editor.
       * Pages Editor environment can be identified only in the browser
       * @returns true if executing within a Pages Editor
       */
      static isActive() {
        return (0, u.default)() ? !1 : window.location.search.indexOf("sc_headless_mode=edit") > -1 || !!window.document.getElementById(e.PAGES_EDITING_MARKER);
      }
      static resetChromes() {
        (0, u.default)() || window[e.ChromeRediscoveryGlobalFunctionName.name] && window[e.ChromeRediscoveryGlobalFunctionName.name]();
      }
    }
    e.HorizonEditor = d;
    const m = () => a.isActive() || d.isActive();
    e.isEditorActive = m;
    const f = () => {
      a.isActive() ? a.resetChromes() : d.isActive() && d.resetChromes();
    };
    e.resetEditorChromes = f;
    const s = () => {
      if (!window || !a.isActive())
        return;
      const r = document.querySelector("body"), n = (c) => {
        c.forEach((l) => {
          const g = document.querySelectorAll('.scChromeDropDown > a[href="#"], .scChromeDropDown > a[href="#!"], a[onclick]');
          l.type === "childList" && g.forEach((v) => {
            v.href = "javascript:void(0);";
          });
        });
      }, i = new MutationObserver(n), o = {
        childList: !0,
        subtree: !0
      };
      r && i.observe(r, o);
    };
    e.handleEditorAnchors = s;
    const t = () => {
      const r = {};
      return r[e.PAGES_EDITING_MARKER] = {}, r;
    };
    e.getJssPagesClientData = t;
  }($)), $;
}
var ee = {}, Pe;
function qe() {
  return Pe || (Pe = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.DefaultEditFrameButtons = e.DefaultEditFrameButton = e.DefaultEditFrameButtonIds = void 0, e.mapButtonToCommand = u, e.commandBuilder = a, e.DefaultEditFrameButtonIds = {
      edit: "{70C4EED5-D4CD-4D7D-9763-80C42504F5E7}"
    }, e.DefaultEditFrameButton = {
      insert: {
        header: "Insert New",
        icon: "/~/icon/Office/16x16/insert_from_template.png",
        click: "webedit:new",
        tooltip: "Insert a new item"
      },
      editRelatedItem: {
        header: "Edit the related item",
        icon: "/~/icon/Office/16x16/cubes.png",
        click: "webedit:open",
        // Command in Sitecore, 'chrome:common:edititem({command:"webedit:open"})',
        tooltip: "Edit the related item in the Content Editor."
      },
      edit: {
        header: "Edit Item",
        icon: "/~/icon/people/16x16/cubes_blue.png",
        fields: ["Title", "Text"],
        tooltip: "Edit the item fields."
      }
    }, e.DefaultEditFrameButtons = [
      e.DefaultEditFrameButton.editRelatedItem,
      e.DefaultEditFrameButton.insert,
      e.DefaultEditFrameButton.edit
    ];
    function h(d) {
      return d.click !== void 0;
    }
    function u(d, m, f) {
      if (d === "|" || d.isDivider)
        return {
          click: "chrome:dummy",
          header: "Separator",
          icon: "",
          isDivider: !0,
          tooltip: null,
          type: "separator"
        };
      if (h(d))
        return a(d, m, f);
      {
        const s = d.fields.join("|"), t = Object.assign({ click: `webedit:fieldeditor(command=${e.DefaultEditFrameButtonIds.edit},fields=${s})` }, d);
        return a(t, m, f);
      }
    }
    function a(d, m, f) {
      if (d.click) {
        if (d.click.startsWith("javascript:") || d.click.startsWith("chrome:"))
          return Object.assign({ isDivider: !1, type: d.type || null, header: d.header || "", icon: d.icon || "", tooltip: d.tooltip || "" }, d);
        if (m) {
          let s = d.click, t = {};
          const r = d.click.indexOf("(");
          if (r >= 0) {
            const o = d.click.indexOf(")");
            if (o < 0)
              throw new Error('Message with arguments must end with ")".');
            t = d.click.substring(r + 1, o).split(",").map((c) => c.trim()).reduce((c, l) => {
              const g = l.split("=");
              return g.length < 2 ? c[g[0]] = "" : c[g[0]] = g[1], c;
            }, {}), s = d.click.substring(0, r);
          }
          t.id = m, d.parameters && Object.keys(d.parameters).forEach((o) => {
            var c;
            t[o] = ((c = d.parameters[o]) === null || c === void 0 ? void 0 : c.toString()) || "";
          }), f && Object.keys(f).forEach((o) => {
            var c;
            t[o] = ((c = f[o]) === null || c === void 0 ? void 0 : c.toString()) || "";
          });
          const n = Object.keys(t).map((o) => `${o}=${t[o]}`).join(", ");
          return {
            isDivider: !1,
            click: `javascript:Sitecore.PageModes.PageEditor.postRequest('${`${s}(${n})`}',null,false)`,
            header: d.header || "",
            icon: d.icon || "",
            tooltip: d.tooltip || "",
            type: d.type || null
          };
        } else
          return Object.assign({ isDivider: !1, type: d.type || null, header: d.header || "", icon: d.icon || "", tooltip: d.tooltip || "" }, d);
      } else return Object.assign({ isDivider: !1, type: d.type || null, header: d.header || "", icon: d.icon || "", tooltip: d.tooltip || "" }, d);
    }
  }(ee)), ee;
}
var Le;
function rt() {
  return Le || (Le = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.MetadataKind = e.LayoutKind = e.mapButtonToCommand = e.DefaultEditFrameButtonIds = e.DefaultEditFrameButtons = e.DefaultEditFrameButton = e.PAGES_EDITING_MARKER = e.QUERY_PARAM_EDITING_SECRET = e.EDITING_ALLOWED_ORIGINS = e.getJssPagesClientData = e.handleEditorAnchors = e.resetEditorChromes = e.isEditorActive = e.HorizonEditor = e.ExperienceEditor = e.DEFAULT_PLACEHOLDER_UID = e.GraphQLEditingService = void 0;
    var h = /* @__PURE__ */ tt();
    Object.defineProperty(e, "GraphQLEditingService", { enumerable: !0, get: function() {
      return h.GraphQLEditingService;
    } });
    var u = /* @__PURE__ */ Ge();
    Object.defineProperty(e, "DEFAULT_PLACEHOLDER_UID", { enumerable: !0, get: function() {
      return u.DEFAULT_PLACEHOLDER_UID;
    } }), Object.defineProperty(e, "ExperienceEditor", { enumerable: !0, get: function() {
      return u.ExperienceEditor;
    } }), Object.defineProperty(e, "HorizonEditor", { enumerable: !0, get: function() {
      return u.HorizonEditor;
    } }), Object.defineProperty(e, "isEditorActive", { enumerable: !0, get: function() {
      return u.isEditorActive;
    } }), Object.defineProperty(e, "resetEditorChromes", { enumerable: !0, get: function() {
      return u.resetEditorChromes;
    } }), Object.defineProperty(e, "handleEditorAnchors", { enumerable: !0, get: function() {
      return u.handleEditorAnchors;
    } }), Object.defineProperty(e, "getJssPagesClientData", { enumerable: !0, get: function() {
      return u.getJssPagesClientData;
    } }), Object.defineProperty(e, "EDITING_ALLOWED_ORIGINS", { enumerable: !0, get: function() {
      return u.EDITING_ALLOWED_ORIGINS;
    } }), Object.defineProperty(e, "QUERY_PARAM_EDITING_SECRET", { enumerable: !0, get: function() {
      return u.QUERY_PARAM_EDITING_SECRET;
    } }), Object.defineProperty(e, "PAGES_EDITING_MARKER", { enumerable: !0, get: function() {
      return u.PAGES_EDITING_MARKER;
    } });
    var a = /* @__PURE__ */ qe();
    Object.defineProperty(e, "DefaultEditFrameButton", { enumerable: !0, get: function() {
      return a.DefaultEditFrameButton;
    } }), Object.defineProperty(e, "DefaultEditFrameButtons", { enumerable: !0, get: function() {
      return a.DefaultEditFrameButtons;
    } }), Object.defineProperty(e, "DefaultEditFrameButtonIds", { enumerable: !0, get: function() {
      return a.DefaultEditFrameButtonIds;
    } }), Object.defineProperty(e, "mapButtonToCommand", { enumerable: !0, get: function() {
      return a.mapButtonToCommand;
    } });
    var d = /* @__PURE__ */ Ne();
    Object.defineProperty(e, "LayoutKind", { enumerable: !0, get: function() {
      return d.LayoutKind;
    } }), Object.defineProperty(e, "MetadataKind", { enumerable: !0, get: function() {
      return d.MetadataKind;
    } });
  }(J)), J;
}
var te, Fe;
function ke() {
  return Fe || (Fe = 1, te = /* @__PURE__ */ rt()), te;
}
var De;
function nt() {
  return De || (De = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getJssEditingSecret = e.handleEditorFastRefresh = e.getPublicUrl = void 0;
    const h = /* @__PURE__ */ ke(), u = () => {
      let m = process.env.PUBLIC_URL;
      if (m === void 0) {
        if (process.env.NETLIFY && process.env.DEPLOY_URL)
          return process.env.DEPLOY_URL;
        if (process.env.VERCEL_URL)
          return `https://${process.env.VERCEL_URL}`;
        m = "http://localhost:3000";
      }
      return m.replace(/\/$/, "");
    };
    e.getPublicUrl = u;
    const a = (m = !1) => {
      if (process.env.NODE_ENV !== "development" || !(0, h.isEditorActive)())
        return;
      const f = new window.EventSource(`${(0, e.getPublicUrl)()}/_next/webpack-hmr`);
      window.addEventListener("beforeunload", () => f.close()), f.onopen = () => console.log("[Sitecore Editor Fast Refresh Listener] Online"), f.onmessage = (s) => {
        if (s.data.indexOf("{") === -1)
          return;
        const t = JSON.parse(s.data);
        if (console.debug(`[Sitecore Editor Fast Refresh Listener] Saw event: ${JSON.stringify(t)}`), t.action === "built") {
          if (m)
            return window.location.reload();
          setTimeout(() => {
            console.log("[Sitecore Editor HMR Listener] Sitecore editor does not support Fast Refresh, reloading chromes..."), (0, h.resetEditorChromes)();
          }, 500);
        }
      };
    };
    e.handleEditorFastRefresh = a;
    const d = () => {
      const m = process.env.JSS_EDITING_SECRET;
      if (!m || m.length === 0)
        throw new Error("The JSS_EDITING_SECRET environment variable is missing or invalid.");
      return m;
    };
    e.getJssEditingSecret = d;
  }(Y)), Y;
}
var N = {}, G = {}, Re;
function it() {
  if (Re) return G;
  Re = 1, Object.defineProperty(G, "__esModule", { value: !0 }), G.tryParseEnvValue = void 0;
  const e = (h, u) => {
    if (!h)
      return u;
    if (h.startsWith("{") && h.endsWith("}"))
      try {
        return JSON.parse(h);
      } catch {
        return console.warn("Parsing of env variable failed"), console.warn(`Attempted to parse ${h}`), u;
      }
    return u;
  };
  return G.tryParseEnvValue = e, G;
}
var Ae;
function at() {
  return Ae || (Ae = 1, function(e) {
    var h = N && N.__importDefault || function(s) {
      return s && s.__esModule ? s : { default: s };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.mapButtonToCommand = e.DefaultEditFrameButtonIds = e.DefaultEditFrameButtons = e.DefaultEditFrameButton = e.handleEditorAnchors = e.resetEditorChromes = e.isEditorActive = e.HorizonEditor = e.ExperienceEditor = e.tryParseEnvValue = e.mergeURLSearchParams = e.escapeNonSpecialQuestionMarks = e.areURLSearchParamsEqual = e.isRegexOrUrl = e.getAllowedOriginsFromEnv = e.enforceCors = e.isTimeoutError = e.isAbsoluteUrl = e.resolveUrl = e.isServer = void 0;
    var u = /* @__PURE__ */ B();
    Object.defineProperty(e, "isServer", { enumerable: !0, get: function() {
      return h(u).default;
    } });
    var a = /* @__PURE__ */ Me();
    Object.defineProperty(e, "resolveUrl", { enumerable: !0, get: function() {
      return a.resolveUrl;
    } }), Object.defineProperty(e, "isAbsoluteUrl", { enumerable: !0, get: function() {
      return a.isAbsoluteUrl;
    } }), Object.defineProperty(e, "isTimeoutError", { enumerable: !0, get: function() {
      return a.isTimeoutError;
    } }), Object.defineProperty(e, "enforceCors", { enumerable: !0, get: function() {
      return a.enforceCors;
    } }), Object.defineProperty(e, "getAllowedOriginsFromEnv", { enumerable: !0, get: function() {
      return a.getAllowedOriginsFromEnv;
    } }), Object.defineProperty(e, "isRegexOrUrl", { enumerable: !0, get: function() {
      return a.isRegexOrUrl;
    } }), Object.defineProperty(e, "areURLSearchParamsEqual", { enumerable: !0, get: function() {
      return a.areURLSearchParamsEqual;
    } }), Object.defineProperty(e, "escapeNonSpecialQuestionMarks", { enumerable: !0, get: function() {
      return a.escapeNonSpecialQuestionMarks;
    } }), Object.defineProperty(e, "mergeURLSearchParams", { enumerable: !0, get: function() {
      return a.mergeURLSearchParams;
    } });
    var d = /* @__PURE__ */ it();
    Object.defineProperty(e, "tryParseEnvValue", { enumerable: !0, get: function() {
      return d.tryParseEnvValue;
    } });
    var m = /* @__PURE__ */ Ge();
    Object.defineProperty(e, "ExperienceEditor", { enumerable: !0, get: function() {
      return m.ExperienceEditor;
    } }), Object.defineProperty(e, "HorizonEditor", { enumerable: !0, get: function() {
      return m.HorizonEditor;
    } }), Object.defineProperty(e, "isEditorActive", { enumerable: !0, get: function() {
      return m.isEditorActive;
    } }), Object.defineProperty(e, "resetEditorChromes", { enumerable: !0, get: function() {
      return m.resetEditorChromes;
    } }), Object.defineProperty(e, "handleEditorAnchors", { enumerable: !0, get: function() {
      return m.handleEditorAnchors;
    } });
    var f = /* @__PURE__ */ qe();
    Object.defineProperty(e, "DefaultEditFrameButton", { enumerable: !0, get: function() {
      return f.DefaultEditFrameButton;
    } }), Object.defineProperty(e, "DefaultEditFrameButtons", { enumerable: !0, get: function() {
      return f.DefaultEditFrameButtons;
    } }), Object.defineProperty(e, "DefaultEditFrameButtonIds", { enumerable: !0, get: function() {
      return f.DefaultEditFrameButtonIds;
    } }), Object.defineProperty(e, "mapButtonToCommand", { enumerable: !0, get: function() {
      return f.mapButtonToCommand;
    } });
  }(N)), N;
}
var re, we;
function ot() {
  return we || (we = 1, re = /* @__PURE__ */ at()), re;
}
var Ie;
function st() {
  return Ie || (Ie = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.resetEditorChromes = e.isEditorActive = e.resolveUrl = e.tryParseEnvValue = e.handleEditorFastRefresh = e.getPublicUrl = void 0;
    var h = /* @__PURE__ */ nt();
    Object.defineProperty(e, "getPublicUrl", { enumerable: !0, get: function() {
      return h.getPublicUrl;
    } }), Object.defineProperty(e, "handleEditorFastRefresh", { enumerable: !0, get: function() {
      return h.handleEditorFastRefresh;
    } });
    var u = /* @__PURE__ */ ot();
    Object.defineProperty(e, "tryParseEnvValue", { enumerable: !0, get: function() {
      return u.tryParseEnvValue;
    } }), Object.defineProperty(e, "resolveUrl", { enumerable: !0, get: function() {
      return u.resolveUrl;
    } });
    var a = /* @__PURE__ */ ke();
    Object.defineProperty(e, "isEditorActive", { enumerable: !0, get: function() {
      return a.isEditorActive;
    } }), Object.defineProperty(e, "resetEditorChromes", { enumerable: !0, get: function() {
      return a.resetEditorChromes;
    } });
  }(z)), z;
}
var ne, je;
function ut() {
  return je || (je = 1, ne = /* @__PURE__ */ st()), ne;
}
var ct = /* @__PURE__ */ ut();
export {
  ct as u
};
